import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class SidebarCategory1 extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string,
    isNew: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.element).isRequired,
  };

  static defaultProps = {
    icon: '',
    isNew: false,
  };

  constructor() {
    super();
    this.state = {
      collapse: false,
    };
  }

  toggle = () => {
    const { collapse } = this.state;
    this.setState({ collapse: !collapse });
  };

  render() {
    const {
      title, icon, isNew, children,changeSidebarVisibility
    } = this.props;
    const { collapse } = (title === "Maintenance" && window.location.href.indexOf("BinconsolidationConfirmation") > -1) ? {collapse: true} : this.state;
    const categoryClass = classNames({
      'sidebar__category-wrap': true,
      'sidebar__category-wrap--open': collapse,
      'sidebar__link sidebar__category': true,
    });

    return (
      <div>
        <button className={categoryClass} type="button" onClick={this.toggle}>
         {icon ? <FontAwesomeIcon icon = {icon} onClick={changeSidebarVisibility} /> : ''}
    
          <p className="sidebar__link-title" style={{ textTransform: 'capitalize'}}>{title}
            {isNew && <span className="sidebar__category-new" />}
          </p>
          <span style={{marginTop: -6}} className="sidebar__category-icon lnr lnr-chevron-right" />
        </button>
        <Collapse isOpen={collapse} className="sidebar__submenu-wrap">
          <ul className="sidebar__submenu">
            <div>
              {children}
            </div>
          </ul>
        </Collapse>
      </div>
    );
  }
}